import { render } from "./BlogDetail.vue?vue&type=template&id=51d2b3b9&ts=true&lang=pug"
import script from "./BlogDetail.vue?vue&type=script&lang=ts"
export * from "./BlogDetail.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__